module.exports = __webpack_public_path__ + "img/Screenshot_1.9887a82f.png";